import { Col, Card, Table, Statistic, Button, Tag, Tooltip } from 'antd';
import { EditOutlined, EyeTwoTone } from '@ant-design/icons';
import '../../styles/VersionManagement.scss';
import { Link } from 'react-router-dom';


const columns = [
  {
    dataIndex: 'field',
    key: 'field',
  },
  {
    dataIndex: 'value',
    key: 'value',
    render: (value: string) => (
      <span
        style={{
          color: value.toString().includes('%') ? parseFloat(value.replace('%', '')) < 0 ? 'red' : undefined : undefined,
        }}
      >
        {value}
      </span>
    ),
  },
];

const DealEconomicsSummaries = ({ span, dealId, dealEconomicsSummaries, headerList, slice = 0,  enabledFeatureList}: { span: number; dealId: number, dealEconomicsSummaries: any[], headerList: any[], slice?: number, enabledFeatureList: string[]}) => {
  const color = [
    '#1677ff',
    '#1677ff',
    '#1677ff'
    // Add more colors here
  ]


  // // Version Summaries
  // const DealEconomicsSummaries = [
  //   {
  //     'Blended Hourly Price': '$120',
  //     'Total Project Price': '$482,763',
  //     'Project Discount Amount': '$10,888',
  //     'Net Project Price': '$431,875',
  //     'Total Project Labor Cost': '$201,810',
  //     'Projected Client Margin %': '53.3%',
  //     'Target Client Margin': '56.0%',
  //     'Variance to Target Margin': '-2.7%',
  //     'Updated By': 'Pavan Attli',
  //     'Updated On': 'Sept 15, 2024, 12:16:00 PM EST',
  //   },
  //   {
  //     'Blended Hourly Price': '$120',
  //     'Total Project Price': '$242,763',
  //     'Project Discount Amount': '$10,888',
  //     'Net Project Price': '$431,875',
  //     'Total Project Labor Cost': '$201,810',
  //     'Projected Client Margin %': '53.3%',
  //     'Target Client Margin': '56.0%',
  //     'Variance to Target Margin': '-2.7%',
  //     'Updated By': 'Pavan Attli',
  //     'Updated On': 'Sept 15, 2024, 1:06:00 PM EST',
  //   },
  //   {
  //     'Blended Hourly Price': '$120',
  //     'Total Project Price': '$442,763',
  //     'Project Discount Amount': '$10,888',
  //     'Net Project Price': '$431,875',
  //     'Total Project Labor Cost': '$201,810',
  //     'Projected Client Margin %': '53.3%',
  //     'Target Client Margin': '56.0%',
  //     'Variance to Target Margin': '-2.7%',
  //     'Updated By': 'Pavan Attli',
  //     'Updated On': 'Sept 15, 2024, 12:36:00 PM EST',
  //   }
  // ];

  // const headerList = ['MVL TEAM STRUCTURE_SEPT092024', 'IND TEAM STRUCTURE_SEPT082024', 'US TEAM STRUCTURE_SEPT072024']

  const formatTableData = (summary: Record<string, string>) => {
    return Object.entries(summary).map(([field, value], index) => ({
      key: index,
      field,
      value
    }));
  };

  const getVersionUrl = (versionName: string, action: string) => {
    if (action === 'edit') {
      return `/edit-pricing-details?dealId=${dealId}&versionName=${encodeURIComponent(versionName)}`;
    }
    return `/view-pricing-details?dealId=${dealId}&versionName=${encodeURIComponent(versionName)}`;
  };

  const isAnyODEStatusTrue = dealEconomicsSummaries.some((record: any) => record['ODE Status']);

  const isEditDisabled = (record: any) => {
    return (isAnyODEStatusTrue && !record['ODE Status']) || !enabledFeatureList.includes('FE_EDIT_PRICING');
  };

  // Display Versions
  const renderCards = () => {
    return dealEconomicsSummaries.map((summary, index) => {
      const tableData = formatTableData(summary);
      const rows = [];
      rows.push(tableData);

      return (
        <Col span={span} key={index} style={{ marginBottom: '16px' }}>
          <Card
            className='version-card'
            title={
              <Statistic
                title={
                  <div>
                    <div style={{ color: 'black' }}>{headerList[index]}</div>
                    <div style={{ color: "lightgray", paddingTop: "10px", fontSize: "12px" }}>
                      <div>Updated by: {summary['Updated By']}</div>
                      <div>Updated at: {summary['Updated On']}</div>
                    </div>
                  </div>
                }
                value={summary['Net Project Price']}
                precision={0}
                valueStyle={{ color: (!isAnyODEStatusTrue || summary['ODE Status']) ? '#1677ff' : '', marginTop: '-4px' }}
                prefix=""
                suffix={<span  style={{marginLeft: '8px', verticalAlign: 'text-bottom' }}>{summary['ODE Status'] == true && <Tag color="#cd201f" >ODE</Tag>}</span >}
                style={{ marginTop: '16px' }}
              />
            }
            actions={
              [
               <div>
                <Tooltip title={'Edit Pricing'}>
                  <Link to={getVersionUrl(headerList[index], 'edit')} style={{ textDecoration: 'none' }}>
                    <Button type='text' disabled={isEditDisabled(summary)}>
                      <EditOutlined key="edit" style={{ color:`${isEditDisabled(summary)? 'gray': "#1677ff"}`}} />
                    </Button>
                  </Link>
                </Tooltip>
                <Tooltip title={'View Pricing'}>
                  <Link to={getVersionUrl(headerList[index], 'view')} style={{ textDecoration: 'none' }}>
                    <Button type='text'>
                      <EyeTwoTone key="view" style={{ color: "#1677ff" }} />
                    </Button>
                  </Link>
                </Tooltip>
                </div> 
              ]
            }

          >
            {rows.map((row, rowIndex) => (
              delete row[9],
              delete row[10],
              <Table
                key={rowIndex}
                columns={columns}
                dataSource={row.slice(slice)}
                pagination={false}
                showHeader={false}
                size="small"
                rowClassName="small-table-row"
                onRow={(record, rowIndex) => ({
                  style: {
                    color: 'black',
                  },
                })}
                style={{ marginBottom: '16px' }}
              />
            ))}
          </Card>
        </Col>
      );
    });
  };

  return (
    <>{renderCards()}</>
  );
};

export default DealEconomicsSummaries;